import { Asset, Entry } from 'contentful'
import { IFact, IFactFields } from 'generated/types/contentful'
import { Document } from '@contentful/rich-text-types'
import { ContentfulLogger } from 'services/Logger'
import { ContentfulEntity, parseSystemFields } from 'services/ContentfulService/utils'

export interface Fact extends ContentfulEntity {
	/** Title */
	title: string

	id: string
	/** Body */
	body?: Document

	/** type */
	type: 'faq' | 'callout' | 'card' | 'none'

	/** graphic */
	graphic?: Asset | undefined
}

export interface FAQ {
	question: string
	id: string
	answer: Document
}

export const parseFact = (rawFact: Entry<IFactFields>): Fact | undefined => {
	const fields = rawFact.fields
	if (fields === undefined) {
		ContentfulLogger.error(`Found null fact fields: ${JSON.stringify(rawFact.sys)}`)
		return undefined
	}

	return {
		id: rawFact.sys.id,
		body: fields.body,
		graphic: fields.graphic,
		title: fields.title,
		type: fields.type || 'none',
		sys: parseSystemFields(rawFact.sys)
	}
}

export const getFaqsFromFacts = (facts: Array<Fact>): FAQ[] => {
	return facts
		.filter(f => f.type === 'faq')
		.map(f => {
			return { answer: f.body!, question: f.title, id: f.id }
		})
}

const parseFactAsFAQ = (rawFact: Entry<IFactFields>): FAQ | undefined => {
	if (rawFact.fields.type != 'faq') return undefined
	return {
		id: rawFact.sys.id,
		answer: rawFact.fields.body!,
		question: rawFact.fields.title
	}
}

export const parseFAQFacts = (array: IFact[] = []): FAQ[] => {
	return array
		.map(item => parseFactAsFAQ(item))
		.reduce((accum, value) => {
			return value ? [...accum, value] : accum
		}, [] as FAQ[])
}
